import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { ReactComponent as BloodBadge } from '../../resources/images/blood-badge.svg';
import { ReactComponent as ImagingBadge } from '../../resources/images/imaging-big-badge.svg';
import { ReactComponent as RocketBadge } from '../../resources/images/rocket-badge.svg';
import { ReactComponent as CheckIcon } from '../../resources/images/circle-check.svg';
import { ReactComponent as BoxIcon } from '../../resources/images/box.svg';
import { ReactComponent as Rectangle } from '../../resources/images/rectangle.svg';

const iconWidthHeight = 30;

const useStyles = makeStyles(theme => ({
    mainContainer: {
        padding: theme.spacing(6),
        paddingBottom: theme.spacing(4) + 1,
    },
    legendContainer: {
        textAlign: 'left',
    },
    legendItem: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(2) + 4,
    },
    legendItemIcon: {
        width: iconWidthHeight,
        height: iconWidthHeight,
        '& svg': {
            width: iconWidthHeight,
            height: iconWidthHeight,
        },
    },
    legendItemLabel: {
        marginLeft: theme.spacing(2),
        fontSize: theme.spacing(2) - 2,
        color: theme.palette.primary.dark,
    },
}));

const LegendItem = ({ Icon, label }) => {
    const classes = useStyles();
    return (
        <div className={classes.legendItem}>
            <div className={classes.legendItemIcon}>
                <Icon />
            </div>
            <div className={classes.legendItemLabel}>{label}</div>
        </div>
    );
};

export default function CalendarIconsInfo() {
    const classes = useStyles();

    const iconList = [
        { label: 'Blood Test', icon: BloodBadge },
        { label: 'Imaging Test', icon: ImagingBadge },
        { label: 'Date of Diagnosis', icon: RocketBadge },
        { label: 'End of Treatment', icon: CheckIcon },
        { label: 'Current Month', icon: BoxIcon },
        { label: 'Past Month', icon: Rectangle },
    ];

    return (
        <div className={classes.mainContainer}>
            <Typography variant="h2">Calendar Information</Typography>
            <div className={classes.legendContainer}>
                {iconList.map((item, idx) => (
                    <LegendItem key={idx} Icon={item.icon} label={item.label} />
                ))}
            </div>
        </div>
    );
}